import React from 'react';

const Iframe = ({ url }: { url: string }) => {
  return <iframe className="flex-1" src={url} />;
};

export default Iframe;
